import { FC, ReactElement, useContext, useMemo, useRef } from 'react';
import { ShopPageSingleDateHeaderProps } from './shopPageSingleDateHeader.types';
import { StyledShopPageDatesHeaderDiv } from './shopPageDatesHeader.styles';
import { StyledShopPageSingleDateBoxDiv } from './shopPageSingleDateHeader.styles';
import { ContentContext, ViewportContext } from '../../index.contexts';
import { isServer } from '@marriott/mi-apollo-client-utils';
import { KR_LOCALE } from '../../../../../../modules/constants';
import { hardCodedAllLocale } from '../../index.constants';
import { getDateText } from './utils';
import clsx from 'clsx';

const ShopPageSingleDateHeaderBox: FC<ShopPageSingleDateHeaderProps> = ({
  checkInMonth,
  onClickCheckIn,
  numberOfNights,
  yearSelected,
  monthSelected,
  backHandler,
  isADFPage,
  currentLocale,
}) => {
  const { flexibleDates, night, nights, stayDates, flexibleDateFormatLabel } = useContext(ContentContext);
  const isMobileView = useContext(ViewportContext);
  const clickTrackingLoc = 'Search Form';

  /**
   * Return react element to display check in/out date and clear button
   * @param label
   * @param date
   * @param onClearHandler
   * @param onClickHandler
   * @param focused
   */
  const DateBox = (
    label: string,
    date: string,
    onClickHandler: () => void,
    focused: boolean,
    currentLocale: string
  ): ReactElement => {
    const mainBtn = useRef<HTMLButtonElement>(null);

    const dateText = useMemo(
      () => getDateText(monthSelected, yearSelected, currentLocale, flexibleDateFormatLabel),
      [monthSelected, yearSelected, currentLocale]
    );

    return (
      <>
        {!isServer && window.screen.width < 576 && !backHandler && (
          <span
            onClick={backHandler}
            className="icon-back-arrow-cropped back-icon arrow-back-icon custom_click_track"
            {...{ custom_click_track_value: `${clickTrackingLoc}| Date Picker back  button click |internal` }}
          ></span>
        )}
        <StyledShopPageSingleDateBoxDiv className="w-100 mr-0" focused={focused}>
          <button
            type="button"
            ref={mainBtn}
            className={`custom_click_track ${isMobileView ? 'mobile-input-field' : ''}`}
            {...{
              custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker Flexible Dates button |internal`,
            }}
            aria-expanded={focused}
            onClick={onClickHandler}
          >
            {/* flag added to hide icons incase of ADF Page */}
            <span
              className={`search__calendar-label ${isADFPage ? '' : 'icon-nav---book single-flex-icon'} t-label-xs `}
            >
              {label}
            </span>
            <span
              className={clsx(
                isMobileView ? 't-subtitle-inverse-l' : 't-subtitle-xl',
                'search-page-date-text',
                !date ? 'gray-shade' : ''
              )}
            >
              {dateText}
            </span>
          </button>
        </StyledShopPageSingleDateBoxDiv>
      </>
    );
  };

  return (
    /* props added to customize styles incase of ADF Page */

    <StyledShopPageDatesHeaderDiv className={`pr-0`} isADFPage={isADFPage}>
      {DateBox(
        `${isMobileView ? flexibleDates : stayDates} (${numberOfNights}${currentLocale === KR_LOCALE ? '' : ' '}${
          numberOfNights && numberOfNights > 1 ? nights : night
        })`,
        checkInMonth,
        onClickCheckIn,
        true,
        currentLocale ?? hardCodedAllLocale.en
      )}
    </StyledShopPageDatesHeaderDiv>
  );
};

export default ShopPageSingleDateHeaderBox;
